import dClient, { clientNoLoader } from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initAdminForm, setAdmins} from "./adminSlice";


export const getAdmins = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient('get', 'admin', {}, {},1, false);
    if (failStatus(res, dispatch)) return '';
    dispatch(setAdmins(res.data.data));
    return callback && callback(res);
};

export const getAdminsByLastName = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await clientNoLoader('get', `admin/admin?last_name=${x}`, {}, {},1, false);
    if (failStatus(res, dispatch)) return '';
    dispatch(setAdmins(res.data.data));
    return callback && callback(res);
};

export const getAdminById = ({id}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `admin/admin/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    const data = {
        first_name: res.data.data.first_name,
        last_name: res.data.data.last_name,
        mobile: res.data.data.mobile,
        national_code: res.data.data.national_code,
        username: res.data.data.username,
        password: ''
    }
    dispatch(initAdminForm(data))
    return callback && callback();
};

export const createAdmin = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/admin`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editAdmin = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/admin/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteAdmin = ({ user_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `admin/admin/${user_id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res,dispatch)) return '';
    return callback && callback(res);
};